import { useSnackbarStore } from '~/stores/snackbar'

export function useSnackbar() {
  const store = useSnackbarStore()

  function show(message: string) {
    store.showMessage(message, 'success')
  }

  function showError(message: string) {
    store.showMessage(message, 'error')
  }

  return {
    show,
    showError
  }
}
